import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=8f85754c&scoped=true"
import script from "./HeaderTitle.vue?vue&type=script&lang=js"
export * from "./HeaderTitle.vue?vue&type=script&lang=js"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&id=8f85754c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f85754c",
  null
  
)

export default component.exports